<template>
  <Modal v-model="openForm" title="选择抬头" width="1000" @on-ok="daochu">
    <Row :gutter="16">
      <Col span="5">
        <dl class="taitou" v-for="x in items" :key="x.id">
          <dt>{{ x.name }}</dt>
          <dd
            :class="{ active: select.x == x.id && select.y == y.id }"
            @click="clickdd(x, y)"
            v-for="y in x.companyTtList"
            :key="y.id"
          >
            {{ y.companyName }}
          </dd>
        </dl>
      </Col>
      <Col span="19">
        <h3>{{ item.companyName }}</h3>
        <p style="margin-bottom: 20px">{{ item.companyNamePy }}</p>
        <Row>
          <Col span="8"
            ><ly-form-item label="TEL">{{ item.tel }} </ly-form-item></Col
          >
          <Col span="8"
            ><ly-form-item label="FAX">{{ item.fax }} </ly-form-item></Col
          ><Col span="8"
            ><ly-form-item label="WEB"
              >{{ item.websiteUrl }}.com
            </ly-form-item></Col
          >
          <Col span="24"
            ><ly-form-item label="公司地址"
              >{{ item.address }}.com
            </ly-form-item></Col
          >
        </Row>
      </Col>
      <Col span="24" style="margin-top: 30px">
        <h3 style="margin-bottom: 20px; font-size: 16px">选择模板</h3>
        <Row>
          <Col v-for="(tt, index) in mubanlist" :key="index" span="3">
            <div
              @click="ctid = tt.id"
              class="mubanlist"
              :class="{ mubanactive: tt.id == ctid }"
            >
              <img width="30" src="static/word.png" />
              <p>{{ tt.name }}</p>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      openForm: false,
      searchItem: {},
      items: [],
      item: {
        id: 2,
        companyName: "",
        companyNamePy: "",
        address: "",
        tel: "",
        fax: "",
        websiteUrl: "",
      },
      select: { x: 0, y: 0 },
      mubanlist: [
        {
          name: "我的模板1",
          id: 3,
        },
        {
          name: "我的模板2",
          id: 3,
        },
        {
          name: "我的模板1",
          id: 1,
        },
        {
          name: "我的模板2",
          id: 2,
        },
        {
          name: "我的模板1",
          id: 1,
        },
        {
          name: "我的模板2",
          id: 2,
        },
      ],
      ctid: 0,
      //http://127.0.0.1:8080/sellQuotation/exportWord?customerId=1648940548849164289&platformId=8162ea2e-29a5-4da7-b2f6-f48a8cc8e6c5&id=22&tid=5&ttid=0
    };
  },
  methods: {
    reach(v) {
      this.openForm = true;
      this.getList();
      this.getMuban();
      this.select.id = v.id;
    },
    clickdd(x, y) {
      this.select.x = x.id;
      this.select.y = y.id;
      this.item = y;
    },

    daochu(v) {
      var params = [
        {
          name: "id",
          value: this.select.id,
        },
        {
          name: "tid",
          value: this.select.x,
        },
        {
          name: "ttid",
          value: this.select.y,
        },
        {
          name: "ctid",
          value: this.ctid,
        },
      ];
      this.utils.exportData(
        this.axios.ipPort + "/cloud-tms-server-smm/sellQuotation/exportWord",
        params
      );
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/exportTemplet/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        this.items = data;
        if (data.length > 0) {
          this.clickdd(data[0], data[0].companyTtList[0]);
        }
      });
    },
    getMuban() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/exportCostTmpl/list",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data.dataList;
        if (data.length > 0) {
          this.ctid = data[0].id;
        }
        this.mubanlist = data;
      });
    },
  },
};
</script>
<style>
.taitou dt {
  color: #878787;
  font-size: 18px;
}
.taitou dd {
  padding: 5px;
  cursor: pointer;
}
.taitou dd.active {
  background: #1da2d7;
  color: #fff;
}
.taitou {
  margin-top: 10px;
}
.taitou:first-child {
  margin-top: 0px;
}
.mubanlist {
  text-align: center;
  margin-bottom: 4px;
}

.mubanlist:hover,
.mubanactive {
  border: solid 2px #f63;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/taitou.vue